export default {
  init() {
    // JavaScript to be fired on all pages
    if (typeof jQuery !== 'undefined') {
      jQuery(document).ready(function() {
        // console.log('jQuery ready in init');
      });
    }
  },
  finalize() {
    jQuery(function($) {
      // Accessible Tab navigation for menu
      function initMenuTabNavigation() {
        const $mainMenu = $('#menu-menu-header'); // Use ID for specificity
        if (!$mainMenu.length) return;

        function showSubmenu($menuItem) {
          $menuItem.addClass('keyboard-focus');
          const $submenu = $menuItem.children('.sub-menu');
          if ($submenu.length) {
            $submenu.css({
              'visibility': 'visible',
              'opacity': '1',
              'transform': 'translate(0, 0)',
            });
          }
        }

        function hideSubmenu($menuItem) {
          $menuItem.removeClass('keyboard-focus');
          const $submenu = $menuItem.children('.sub-menu');
          if ($submenu.length) {
            $submenu.css({
              'visibility': 'hidden',
              'opacity': '0',
              'transform': '',
            });
          }
        }

        function hideAllSubmenus() {
          $mainMenu.find('.sub-menu').css({
            'visibility': 'hidden',
            'opacity': '0',
            'transform': '',
          });
          $mainMenu.find('.menu-item-has-children').removeClass('keyboard-focus');
        }

        function handleTabForward($currentLink) {
          const $currentItem = $currentLink.closest('.menu-item');

          // 1. If it has children and submenu is not open, go into the submenu.
          if ($currentItem.hasClass('menu-item-has-children')) {
            const $submenu = $currentItem.children('.sub-menu');
            if ($submenu.length && !$currentItem.hasClass('keyboard-focus')) {
              showSubmenu($currentItem);
              $submenu.find('a:first').focus();
              return true;
            }
          }

          // 2. Try to go to the next item in the current list.
          const $nextSibling = $currentItem.next('.menu-item');
          if ($nextSibling.length) {
            $nextSibling.find('a:first').focus();
            return true;
          }

          // 3. No sibling, go up the tree, closing menus as we go.
          let $ancestor = $currentItem.parent().closest('.menu-item');
          while ($ancestor.length) {
            hideSubmenu($ancestor); // Close the menu we're leaving.

            const $nextAncestorSibling = $ancestor.next('.menu-item');
            if ($nextAncestorSibling.length) {
              $nextAncestorSibling.find('a:first').focus();
              return true;
            }
            $ancestor = $ancestor.parent().closest('.menu-item');
          }

          // 4. Reached the end of the menu.
          return false;
        }

        function handleTabBackward($currentLink) {
          const $currentItem = $currentLink.closest('.menu-item');

          // 1. Try to go to the previous sibling.
          const $prevSibling = $currentItem.prev('.menu-item');
          if ($prevSibling.length) {
            let $target = $prevSibling;
            // If the previous sibling has children, navigate to its last descendant.
            while ($target.hasClass('menu-item-has-children') && $target.children('.sub-menu').length) {
              showSubmenu($target); // Make sure it's visible
              const $lastChild = $target.children('.sub-menu').children('.menu-item:last');
              if ($lastChild.length) {
                $target = $lastChild;
              } else {
                break; // Submenu is empty
              }
            }
            $target.find('a:first').focus();
            return true;
          }

          // 2. No previous sibling, go to the parent item.
          const $parentItem = $currentItem.parent().closest('.menu-item');
          if ($parentItem.length) {
            hideSubmenu($parentItem);
            $parentItem.find('a:first').focus();
            return true;
          }

          // 3. Reached the beginning of the menu.
          return false;
        }

        $(document).on('keydown', function(e) {
          if (e.key === 'Tab') {
            const $activeElement = $(document.activeElement);
            if ($activeElement.closest($mainMenu).length) {
              // Find all *visible* links to account for responsive classes like d-lg-none
              const $visibleLinks = $mainMenu.find('a').filter(':visible');
              const $lastLink = $visibleLinks.last();

              // Special case: handle tabbing out from the last item.
              if (!e.shiftKey && $activeElement[0] === $lastLink[0]) {
                console.log('Tabbing from the last menu item. Allowing default browser behavior.');
                hideAllSubmenus();
                return; // Let the browser handle tabbing to the next element.
              }

              const handled = e.shiftKey ? handleTabBackward($activeElement) : handleTabForward($activeElement);

              if (handled) {
                e.preventDefault();
              } else {
                // If not handled, it means we are at the start (and shift-tabbing).
                // The end case is handled by the special case above.
                hideAllSubmenus();
              }
            }
          }
        });

        // Fallback for clicks outside the menu.
        $(document).on('click', function(e) {
          if (!$(e.target).closest($mainMenu).length) {
            hideAllSubmenus();
          }
        });
      }

      initMenuTabNavigation();

      // Header transition on scroll
      $(window).scroll(function() {
        let headerHeight = $('header.header').outerHeight();
        let pageScroll = $(this).scrollTop();
        if (pageScroll > headerHeight) {
          $('header.header').addClass('scrolled');
        } else {
          $('header.header').removeClass('scrolled');
        }
      });

      // Mmenu
      if ($('#mobile-menu').length) {
        const menuNode = document.querySelector('#mobile-menu');
        const trigger = document.querySelector('a[href="#mobile-menu"]');

        new window.Mmenu(menuNode, {
          'offCanvas': {
            'position': 'right-front',
          },
          'theme': 'white',
          'navbars': [
            {
              'position': 'top',
              'content': [
                'prev',
                'title',
                'close',
              ],
            },
          ],
          hooks: {
            'open:after': () => {
              $('#mobile-menu .mm-panel--opened').find('a, button').first().focus();
            },
            'close:after': () => {
              if (trigger) {
                trigger.focus();
              }
            },
          },
        });
      }

      //JSShare
      var shareItems = document.querySelectorAll('.social_share');
      for (var i = 0; i < shareItems.length; i += 1) {
        shareItems[i].addEventListener('click', function share() {
          return window.JSShare.go(this);
        });
      }

      // Clipboard
      new window.ClipboardJS('.clipboard');

      // Tooltip
      var toolTipsItems = document.querySelectorAll('[data-bs-toggle="tooltip"]');
      for (var j = 0; j < toolTipsItems.length; j += 1) {
        new window.Tooltip(toolTipsItems[j]);
      }

      // Anchor navigation
      $('a[href*="#"]:not([href="#"])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {
          var headerHeight = $('header.header').outerHeight();
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
          if (target.length) {
            $('html,body').stop().animate({
              scrollTop: target.offset().top - headerHeight,
            }, 'linear');
          }
        }
      });
      var hash = window.location.hash;
      if ( hash == '' || hash == '#' || hash == undefined ) return false;
      var target = $(hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        var headerHeight = $('header.header').outerHeight();
        $('html,body').stop().animate({
          scrollTop: target.offset().top - headerHeight,
        }, 'linear');
      }
    });
  },
};
